module.exports = __webpack_public_path__ + "static/media/two.85903d64.svg";